import React, { useState } from "react";
import { Alert, Card, Col, Row } from "react-bootstrap";
import ModuleDisplayDateTime from "../../../../UI/modules/fieldsDisplay/ModuleDisplayDateTime";
import useConfirm from "../../../../../HOC/custom/useConfirm";
import { FaBowlFood } from "react-icons/fa6";
import moduleConfig from "../../moduleConfig";
import { Link, useParams } from "react-router-dom";
import {
  getDayName,
  isDatePassed,
  isToday,
  isTomorrow,
} from "../../../../../helpers/CommonHelper";
import { Store as toast } from "react-notifications-component";
import { toastNotification } from "../../../../../config/toastNotification";
import axios from "../../../../../config/axios";
const Details = ({ item, date, loadItems }) => {
  const { confirm } = useConfirm();
  let { id } = useParams();
  const handleSelectDefault = async (a, b, c) => {
    try {
      const res = await axios.post(`${moduleConfig.url}/set-default-food`, {
        date: a,
        mealId: b,
        defaultFoodId: c,
      });
      if (res.status) {
        loadItems();
        toast.addNotification({
          ...toastNotification,
          title: "Success!",
          message: `Food selected as default meal.`,
          type: "success",
        });
      }
    } catch (error) {
      toast.addNotification({
        ...toastNotification,
        title: "Error!",
        message: `Default meal selection failed.`,
        type: "error",
      });
    }
  };
  return (
    <>
      <Row>
        <Col>
          <Card className="item mb-2 borderCream">
            <Card.Header className="ps-1 pe-2 py-0">
              <Card.Title className="d-flex m-0 p-0">
                <div className="d-flex ImageSectionSpacing">
                  <div className="checkboxCol me-2 mt-2"></div>

                  <div className="position-relative ms-2 mt-1 me-2">
                    <FaBowlFood
                      style={{ fontSize: "30px" }}
                      className={`fa fa-cutlery position-relative usericon`}
                    />
                  </div>
                  <div className="d-flex flex-column ms-1">
                    <span className="m-0 text-bold memberName text-red">
                      {date}
                    </span>

                    <span className="text-custom-4 mt-1 small text-bold">
                      {getDayName(date)}
                    </span>
                  </div>
                </div>
              </Card.Title>
              <div
                className="card-tools endColumn mb-1"
                style={{ zIndex: 101, position: "relative" }}
              >
                <div className=" text-right mx-2 mt-3">
                  {isDatePassed(id) && (
                    <span
                      className={`badge fw-semibold badge-dark rounded-pill shadow-sm me-3 px-2`}
                    >
                      Past Day
                    </span>
                  )}
                </div>
              </div>
            </Card.Header>
            <Card.Body className="px-2 py-2">
              <Row>
                {item?.meals &&
                  item?.meals?.map((meal) => {
                    const mealTitle = meal.title;

                    const foods = item.menuItems[mealTitle] || []; // 👈 safely get foods (or empty array)
                    const defaultFood = item.menuItems["defaultFood"] || [];
                    const defaultSelectedFood = defaultFood[meal?.title];
                    const count = foods.length;

                    // Background, borders, and text colors based on count
                    const bgColor = isDatePassed(id)
                      ? "#eee"
                      : count < 1
                      ? "#ffecec"
                      : count < 2
                      ? "#fff8cc"
                      : "#e6f8e6";
                    const borderColor =
                      count < 1 ? "#ffc2c2" : count < 2 ? "#ffed80" : "#a4e2a0";
                    const textColor = "#2A1008";

                    // Button setup
                    const showButton = count < 2;
                    const buttonLabel =
                      count < 1 ? "Select Meals" : "Select More";
                    const buttonBg = count < 1 ? "#ff9999" : "#ffe680";
                    const buttonHover = count < 1 ? "#ff7a7a" : "#ffdb4d";

                    const updateBg = "#baf5b2";
                    const updateHover = "#9ae78a";

                    return (
                      <Col
                        key={meal._id}
                        md={3}
                        sm={6}
                        xs={12}
                        className="mb-3"
                      >
                        <div
                          className="border rounded  shadow-sm d-flex flex-column justify-content-between"
                          style={{
                            backgroundColor: bgColor,
                            borderColor: borderColor,
                            color: textColor,
                            transition:
                              "background-color 0.3s ease, border-color 0.3s ease",
                          }}
                        >
                          {/* Header */}
                          <h6
                            className="fw-bold py-1 px-2 mb-2 mt-0 text-center rounded-top"
                            style={{
                              backgroundColor: "rgba(0,0,0,0.05)",
                            }}
                          >
                            {mealTitle}{" "}
                            <span className="font-small">
                              ({count} selected)
                            </span>
                          </h6>

                          {/* Meals List */}
                          <div className="px-3 flex-grow-1">
                            {count > 0 ? (
                              foods.map((food, index) => {
                                const isDefault =
                                  defaultSelectedFood?._id === food?._id;
                                const noDefault = !defaultSelectedFood; // <-- key condition
                                return (
                                  <div
                                    key={index}
                                    className={`d-flex align-items-center mb-2 rounded px-2 py-1 food-item ${
                                      !isDatePassed(id) &&
                                      !isToday(id) &&
                                      !isTomorrow(id)
                                        ? "cursor-pointer"
                                        : "cursor-normal"
                                    }  ${isDefault ? "always-show-radio" : ""}`}
                                    style={{
                                      backgroundColor: "rgba(255,255,255,0.3)",
                                    }}
                                  >
                                    {!isDatePassed(id) &&
                                      !isToday(id) &&
                                      !isTomorrow(id) && (
                                        <input
                                          type="radio"
                                          title="Click to set food as default food"
                                          className="me-2 food-radio"
                                          checked={
                                            defaultSelectedFood?._id ===
                                            food?._id
                                          }
                                          onChange={
                                            defaultSelectedFood?._id ===
                                            food?._id
                                              ? () => null
                                              : () =>
                                                  handleSelectDefault(
                                                    item.date,
                                                    meal?._id,
                                                    food._id
                                                  )
                                          }
                                          style={{ cursor: "pointer" }}
                                        />
                                      )}

                                    {food.image && (
                                      <img
                                        src={`
                                     ${
                                       process.env.REACT_APP_BACKEND_URL +
                                       "public/" +
                                       food.image
                                     }
                                    `}
                                        className="rounded"
                                        style={{
                                          width: "40px",
                                          height: "40px",
                                          objectFit: "cover",
                                          marginRight: "12px",
                                        }}
                                      />
                                    )}
                                    <div className="flex-grow-1 text-truncate">
                                      <span
                                        className="fw-semibold small"
                                        style={{ fontSize: "13px" }}
                                        title={food.title}
                                      >
                                        {food.title}
                                      </span>
                                    </div>
                                    <span
                                      className={`badge badge-pill ${
                                        food.vegOrNonVeg === "Veg"
                                          ? "bg-success"
                                          : "bg-danger"
                                      } text-light`}
                                      style={{ fontSize: "0.65rem" }}
                                    >
                                      {food.vegOrNonVeg}
                                    </span>
                                  </div>
                                );
                              })
                            ) : (
                              <div
                                className="small fst-italic text-center text-muted py-2"
                                style={{ fontSize: "15px" }}
                              >
                                No items
                              </div>
                            )}
                          </div>

                          {/* Button */}
                          {!isDatePassed(id) &&
                            !isToday(id) &&
                            !isTomorrow(id) && (
                              <div className="text-center pb-2 mt-auto">
                                {showButton ? (
                                  <Link
                                    to={`/menu/update/${meal.title}/${id}`}
                                    className="btn btn-sm border-0 px-3 py-1 fw-semibold"
                                    title={`Update menu`}
                                    style={{
                                      backgroundColor: showButton
                                        ? buttonBg
                                        : "#baf5b2",
                                      color: "#2A1008",
                                      transition: "background-color 0.2s ease",
                                    }}
                                    onMouseEnter={(e) =>
                                      (e.target.style.backgroundColor =
                                        showButton ? buttonHover : "#9ae78a")
                                    }
                                    onMouseLeave={(e) =>
                                      (e.target.style.backgroundColor =
                                        showButton ? buttonBg : "#baf5b2")
                                    }
                                  >
                                    {buttonLabel}
                                  </Link>
                                ) : (
                                  <Link
                                    to={`/menu/update/${meal.title}/${id}`}
                                    className="btn btn-sm border-0 px-3 py-1 fw-semibold"
                                    title={`Update menu`}
                                    style={{
                                      backgroundColor: showButton
                                        ? buttonBg
                                        : "#baf5b2",
                                      color: "#2A1008",
                                      transition: "background-color 0.2s ease",
                                    }}
                                    onMouseEnter={(e) =>
                                      (e.target.style.backgroundColor =
                                        showButton ? buttonHover : "#9ae78a")
                                    }
                                    onMouseLeave={(e) =>
                                      (e.target.style.backgroundColor =
                                        showButton ? buttonBg : "#baf5b2")
                                    }
                                  >
                                    Update
                                  </Link>
                                )}
                              </div>
                            )}
                        </div>
                      </Col>
                    );
                  })}
              </Row>
            </Card.Body>
          </Card>
        </Col>
      </Row>
    </>
  );
};

export default Details;
